export const isMe = (person, uid) => {
  return person?.companyPerson?.uid === uid
}
